export const SessionMap = {
  'cacheData.data.AriesReservation.isMemberRate': 'isMemberRate',
};
